import Vue from "vue";
import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { toData, to } from "./promiseHandle";
import { AuthenService } from "@/services/authen.service.ts";
// import { Proposal, ProposalItem } from '@/models/Coupon';
import { CommonService } from '@/services/Common.service';

export class MenuService extends Vue {
  private baseAPI = process.env.VUE_APP_API_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();

  constructor() {
    super();
  }

  get headers() {
    return {
      "Content-Type": "application/json",
      auth: localStorage.getItem("token")
    };
  }


  public async getMenu() {
    const { result } = await this.commonService.get(
      `${this.baseAPI}/admin/menu`
    );
    if (result) {
      return result.data;
    } else {
      return [];
    }
  }

  public async saveMenuAuthority(data: any) {
    const { result, error } = await this.commonService.put(
      `${this.baseAPI}/admin/menu`, data
    );
    if (result) {
      return result.status;
    } else if (error) {
      return error.status;
    }
    return null;
  }

  public async updateInsertMenu(data: any) {
    const { result, error } = await this.commonService.post(
      `${this.baseAPI}/admin/menu`, data
    );
    if (result) {
      return result.status;
    } else if (error) {
      return error.status;
    }
    return null;
  }

  public async getNavigation() {
    const { result } = await this.commonService.get(
      `${this.baseAPI}/admin/navigation`
    );
    if (result) {
      return result.data;
    } else {
      return [];
    }
  }
}
